import { Box, Typography, Card, CardMedia } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import learner from "@assets/images/Online learning-amico.png";
import { trimLongText } from "@shared/Helpers/Text/trimLongText";
import { FONT_SIZES } from "@constants/Fonts/font_sizes";
import { FONTS } from "@constants/Fonts/fonts";
import Row from "@shared/Layout/Row/Row";
import { COLORS } from "@constants/Colors/colors";
import Column from "@shared/Layout/Column/Column";
import useCustomQuery from "@shared/Helpers/hooks/useCustomQuery";
import getImageUrl from "@shared/Helpers/image/getImageUrl";
import { useRecoilState } from "recoil";
import { activeCourseAtom } from "@/Admin/Pages/Courses/RecoilAtoms/ActiveCourse.atom";
import { ClipLoader } from "react-spinners";

export default function CourseCard({ courseId, parent }) {
  const navigate = useNavigate();
  const path = useLocation();

  // const handleClickCard = () => {
  //   if (path.pathname.includes("coursesCodes")) {
  //     navigateToCodesTable();
  //   } else if (
  //     path.pathname.includes(`/courses`) ||
  //     path.pathname.includes(`/additional`)
  //   ) {
  //     return;
  //   } else {
  //     navigate(`/dashboard/courses/course/${courseId}`);
  //   }
  // };

  const { data: course } = useCustomQuery({
    method: "post",
    url: `course/courseData?id=${courseId}`,
    key: ["course", courseId],
  });
  console.log(course?.price);
  const [_, setActiveCourse] = useRecoilState(activeCourseAtom);

  return (
    <>
      <Card
        onClick={() => {
          if (parent === "courses") {
            setActiveCourse(course);
          } else {
            navigate(`/dashboard/coursesCodes/course/${courseId}`);
            setActiveCourse(course);
          }
        }}
        onDoubleClick={() => {
          if (parent === "courses") {
            navigate(`/dashboard/courses/course/${courseId}`);
          }
        }}
        sx={{
          cursor: "pointer",
          width: "100%",
          borderRadius: "5%",
          position: "relative",
          bgcolor: COLORS.PRIMARY.MAIN,
          fontFamily: FONTS.REGULAR,
        }}
      >
        <Box sx={{ position: "relative" }}>
          {getImageUrl(course?.image) ? (
            <CardMedia
              sx={{
                height: 264,
                backgroundPosition: "top",
                backgroundSize: "contain",
                backgroundColor: "white",
              }}
              image={getImageUrl(course?.image)}
              title="teacher img"
            />
          ) : (
            <Box
              sx={{
                width: "100%",
                height: 264,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ClipLoader size={40} color={COLORS.PRIMARY.MAIN} />
            </Box>
          )}

          <Box
            position={"absolute"}
            bottom={5}
            left={5}
            sx={{
              backgroundColor: COLORS.SECONDARY.MAIN,
              zIndex: "2",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            color={"white"}
            fontFamily={"Noor-regular"}
            fontSize={10}
            textAlign={"center"}
          >
            {course?.duration || 2}
          </Box>
        </Box>
        <Box sx={{ color: COLORS.WHITE }} mt={1} mb={1} px={2}>
          <Row spacing="space-between">
            <Typography fontSize={FONT_SIZES.REGULAR} fontFamily={FONTS.BOLD}>
              {course?.name || "كورس"}
            </Typography>
            <Box>
              <Row gap={0.5}>
                <Typography
                  fontSize={FONT_SIZES.REGULAR}
                  fontFamily={FONTS.BOLD}
                >
                  {course?.subscriptionsCount || 0}
                </Typography>
                <Typography
                  fontSize={FONT_SIZES.EXTRA_SMALL}
                  fontFamily={FONTS.REGULAR}
                >
                  طلاب
                </Typography>
              </Row>
              <Row gap={0.5}>
                <Typography
                  fontSize={FONT_SIZES.REGULAR}
                  fontFamily={FONTS.BOLD}
                >
                  {course?.modulesCount || 0}
                </Typography>
                <Typography
                  fontSize={FONT_SIZES.EXTRA_SMALL}
                  fontFamily={FONTS.REGULAR}
                >
                  حصص
                </Typography>
              </Row>
            </Box>
          </Row>

          <Column gap={1} spacing="flex-start">
            <Typography fontSize={FONT_SIZES.SMALL} fontFamily={FONTS.REGULAR}>
              {trimLongText(course?.description, 30)}
            </Typography>
            {/* <Typography
              fontSize={FONT_SIZES.REGULAR}
              fontFamily={FONTS.REGULAR}
            >
              {course?.data?.teacher?.name || "مستر اياد"}{" "}
            </Typography> */}
            <Typography
              fontSize={FONT_SIZES.REGULAR}
              fontFamily={FONTS.REGULAR}
            >
              {course?.price == 0 ? "مجاني" : `${course?.price} جنيه`}
            </Typography>
          </Column>
        </Box>
      </Card>
    </>
  );
}
